import { DocumentType } from '@domain/models/document/document-type'

// ==================== FIELD INPUT TYPE ====================

export type FieldInputTypeValue = {
  name: string
}

const fieldInputTypeMap: Record<string, FieldInputTypeValue> = {
  select: { name: 'select' },
  checkbox: { name: 'checkbox' },
  toggle: { name: 'toggle' },
  document: { name: 'document' }
}

export const FieldInputType = {
  SELECT: fieldInputTypeMap['select'],
  CHECKBOX: fieldInputTypeMap['checkbox'],
  TOGGLE: fieldInputTypeMap['toggle'],
  DOCUMENT: fieldInputTypeMap['document']
}

// ==================== FIELD ACCESS LEVEL ====================

export type FieldAccessLevelValue = {
  name: string
}

const fieldAccessLevelMap: Record<string, FieldAccessLevelValue> = {
  full_access: { name: 'full_access' },
  readonly: { name: 'readonly' },
  backoffice_only: { name: 'backoffice_only' }
}

export const FieldAccessLevel = {
  FULL_ACCESS: fieldAccessLevelMap['full_access'],
  READONLY: fieldAccessLevelMap['readonly'],
  BACKOFFICE_ONLY: fieldAccessLevelMap['backoffice_only']
}

// ==================== FIELD TYPE ====================

export type FieldTypeValue = {
  name: string
}

const fieldTypeMap: Record<string, FieldTypeValue> = {
  STRING: { name: 'STRING' },
  BOOLEAN: { name: 'BOOLEAN' },
  INTEGER: { name: 'INTEGER' },
  DECIMAL: { name: 'DECIMAL' },
  DATE: { name: 'DATE' },
  DATETIME: { name: 'DATETIME' }
}

export const FieldType = {
  STRING: fieldTypeMap['STRING'],
  BOOLEAN: fieldTypeMap['BOOLEAN'],
  INTEGER: fieldTypeMap['INTEGER'],
  DECIMAL: fieldTypeMap['DECIMAL'],
  DATE: fieldTypeMap['DATE'],
  DATETIME: fieldTypeMap['DATETIME']
}

// ==================== CONFIGURATION DOMAIN MODEL ====================

type FieldConfigOption = { value: string; label: string }

type FieldConfigDependsOn = {
  key: string
  expectedValue: string
}

type FieldConfig = {
  inputType: FieldInputTypeValue | undefined
  options?: FieldConfigOption[]
  validation?: { required?: boolean }
  placeholder?: string
  documentType?: DocumentType.Enum
  dependsOn?: FieldConfigDependsOn
}

type ConfigurationModel = {
  key: string
  displayName: string
  description: string | null
  segment: string
  type: FieldTypeValue | undefined
  displayOrder: number
  fieldConfig: FieldConfig
  accessLevel: FieldAccessLevelValue | undefined
  defaultValue: string | null
  currentValue: string | null
  effectiveValue: string | null
  updatedAt: string | null
}

type ConfigurationUpdateModel = { key: string; value: string | null }

export namespace Configuration {
  export type Model = ConfigurationModel
  export type Update = ConfigurationUpdateModel
}

// ==================== RAW API TYPES ====================

export type RawFieldConfigOption = { value: string; label: string }

export type RawFieldConfig = {
  inputType: string
  options?: RawFieldConfigOption[]
  validation?: { required?: boolean }
  documentType?: string
  dependsOn?: { key: string; expectedValue: string }
}

export type RawConfiguration = {
  key: string
  displayName: string
  description: string | null
  segment: string
  type: string
  displayOrder: number
  fieldConfig: RawFieldConfig
  accessLevel: string
  defaultValue: string | null
  currentValue: string | null
  effectiveValue: string | null
  updatedAt: string | null
}
